import { useNavigate } from 'react-router-dom'
import { Container, Button, Typography } from '@mui/material'

const Unauthorized = () => {
  const navigate = useNavigate()

  const goBack = () => navigate(-1)

  return (
    <Container
      sx={{
        position: 'fixed',
        top: '100px',
        left: 0,
        right: 0,
        bottom: '100px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}
      >
        401 Unauthorized
      </Typography>
      <Typography sx={{ mt: 2 }}>
        You do not have permission to access this page.
      </Typography>
      <Button variant="contained" onClick={goBack} sx={{ mt: 2 }}>
        Go Back
      </Button>
    </Container>
  )
}

export default Unauthorized
